import { print } from 'graphql';
import { gql } from 'graphql-tag';

import { getDateModified } from '../../utilities/utilityFunctions';
import { defaultDoc, getValueFromLocalStorage } from '../share/defaultDoc';
import type { ComponentType } from './componentType.types';

export const componentTypePullQueryBuilder = (document: ComponentType) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }

  const query = print(gql`
    query componentTypeFeed($discipline: Int!, $lastRequested: DateTime!) {
      componentTypeFeed(discipline: $discipline, lastRequested: $lastRequested) {
        name
        id
        discipline
        sort
        isActive
        dateModified
        abbrv
        assetCategory
        site
        dateCreated
      }
    }
  `);

  return {
    query,
    variables: {
      discipline: JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
      lastRequested: getDateModified(
        doc?.dateModified,
        doc?.dateCreated,
        JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
        doc.discipline,
        JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
        JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
      ),
    },
  };
};
